/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SearchControl from 'app/components/common/SearchControl.jsx';
import Combobox from 'react-widgets/Combobox';

class ImportSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentSearch: ''
        };

        this.searchHandler = this.searchHandler.bind(this);
        this.searchChangeHandler = this.searchChangeHandler.bind(this);
        this.onGo = this.onGo.bind(this);
        this.searchControl = React.createRef();

    }

    searchHandler(e, search) {

        if (e) {
            this.setState({
                currentSearch: search,
                resetSearch: false
            });
            e.persist();
            this.props.onSearch(e, search);
        }

    }

    // Go searches for what's typed now, rather than waiting for the field's pause in typing
    onGo(e) {

        if (this.searchControl.current) {
            this.searchControl.current.onSearchClick(e);
        }

    }

    searchChangeHandler(item, e) {

        this.setState({
            resetSearch: true
        }, () => {
            if (e.persist !== undefined) {
                e.persist();
            }
            this.props.onSearchTypeChange(item, e);
        });

    }

    render() {
        let title = "Search for Content",
            placeholder = (1 || this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) ? "Search for content by keyword or URL." : "Search for content, hashtags, or users.",
            promo = null,
            options = [
                {
                    id: 0,
                    label: (1 || this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) ? 'Feeds' : 'X (Twitter) & Feeds'
                },
                {
                    id: -1,
                    label: '+ Connect WordPress Blog'
                }
            ];

        if (this.props.connection && this.props.connection.name) {
            title = "Search " + this.props.connection.name;
            placeholder = "Search posts";
            promo = (
                <div className="wp-promo">
                    <a href="#" onClick={(e) => {
                            e.preventDefault();
                            e.persist();
                            this.setState({
                                resetSearch: true
                            }, () => {
                                this.props.triggerSearch(e, '');
                            })
                        }}>View this blog’s recent posts</a>
                </div>
            );
        }

        if (this.props.connections.length) {
            options.splice(1);
            for (let i = 0; i < this.props.connections.length; ++i) {
                options.push({
                    id: this.props.connections[i].id,
                    label: this.props.connections[i].name
                });
            }
        }

        return (
            <div className="import-search-block">
                <h2>{title}</h2>
                <div className="import-search-controls">
                    <Combobox
                        data={options}
                        textField='label'
                        dataKey='id'
                        filter={false}
                        containerClassName="text-input combobox"
                        inputProps={{'aria-label': 'Source'}}
                        value={this.props.gaID}
                        onChange={() => {}}
                        onSelect={this.searchChangeHandler}
                        suggest={'true'} />
                    <SearchControl
                        {...this.props}
                        ref={this.searchControl}
                        changeHandler={this.searchHandler}
                		placeholder={placeholder}
                        extraClasses="text-input search-control"
                        reset={this.state.resetSearch}/>
                    <button className="btn-primary fixed active" onClick={this.onGo}>
                        Go
                    </button>
                </div>
                {promo}
            </div>
        );
    }
}

ImportSearch.displayName = "ImportSearch";

ImportSearch.propTypes = {
    onSearch: PropTypes.func,
    connection: PropTypes.object,
    connections: PropTypes.array
};

ImportSearch.defaultProps = {
    onSearch: () => {},
    connection: {},
    connections: []
};

export default ImportSearch;
